var charSet = ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z', '0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '-', '\''];
var key = [true , false, false, false, true, false, true, true, false, false, true];
var appList = {
    apps: ['sp', 'rns', 'lks', 'bsrm', 'mvg', 'bcs', 'bnds', 'bps', 'bsds', 'ds', 'gkg', 'rps', 'kkp'],
    appNamesPrefix: ['His Divine Grace', '', '', '', '', '', '', '', '', '', '', '', 'His Grace'],
    appNames: ['A C Bhakti Vedānta Swāmi', 'Rādhānāth Swāmi', 'Lokanāth Swāmi', 'Bhakti Rasāmrita Swāmi', 'Mahavishnu Goswāmi', 'Bhakti Chāru Swāmi', 'Badarinārāyana Dās Goswāmi', 'Bhakti Prema Swāmi', 'Bhakti Swarup Dāmodara Swāmi', 'Devāmrita Swāmi', 'Gopāl Krishna Goswāmi', 'Romapāda Swāmi', 'Kundal Krishna Prabhu'],
    git: ['srila-prabhupada-vani', 'radhanatha-swami', 'lokanatha-swami', 'bhaktirasamrita-swami', '', 'bhakticharu-swami', '', '', '', '', '', '', ''],
    appNamesMobile: ['Prabhupada', ' Lectures and Kirtans', '', '', '', '', '', '', '', '', '', '', ''],
    pkg:['', 'krishnaapps.radhanathswami', 'krishnaapps.lokanathswami', '', '', '', '', '', '', '', '', '',''],
    decode: function(s){
        if (!s || s.trim().length <= 0) return -1;
        var k = 0, base = charSet.length;
        for(var i = 0; i<s.length; i++){
            k += Math.pow(base,i)*(charSet.indexOf(s.charAt(i)));
        }
        return k;
    },
    encodeUrl: function(str){
        if(null == str) return "";
        var sb = '';
        for(var i = 0, j = 0; i<str.length; i++, j++){
            if(str.charAt(i)==' ')
                sb = sb + str.charAt(i);
            else if(key[j%key.length])
                sb = sb + String.fromCharCode(str.charCodeAt(i)-1);
            else
                sb = sb + String.fromCharCode(str.charCodeAt(i)+1);
        }
        return sb;
    },
    decodeUrl: function(str){
        if(null == str) return "";
        var sb = '';
        for(var i = 0, j = 0; i<str.length; i++, j++){
            if(str.charAt(i)==' ')
                sb = sb + str.charAt(i);
            else if(key[j%key.length])
                sb = sb + String.fromCharCode(str.charCodeAt(i)+1);
            else
                sb = sb + String.fromCharCode(str.charCodeAt(i)-1);
        }
        return sb;
    },
}
export default appList


// WEBPACK FOOTER //
// ./src/appList.js